module.exports = __webpack_public_path__ + "1e29e4452ef0d493c2811c26009bfd6b.svg";